module.exports = __webpack_public_path__ + "img/1界面展示.c8d99f35.png";